import { FlexEntitySchema } from "../models/flexible/flex-entity-schema";
import { FlexSectionSchema } from "../models/flexible/flex-section-schema";
import { isSectionEmbedded } from "../models/flexible/utils";
import { isEmptyValue } from "./is-empty-value";

const getAttributeValue = (data: any, identifier: string): any => {
	if (Array.isArray(data)) return data.map((item) => item[identifier]).filter((value) => value != null);
	return data[identifier];
};

export const flattenFlexEntityDataSection = (data: any, schema: FlexSectionSchema): any => {
	const currentSectionData = isSectionEmbedded(schema) ? data : data?.[schema.localizableKey];
	if (isEmptyValue(currentSectionData)) {
		return {};
	}

	const sectionsData = schema.sections?.reduce(
		(result, nestedSection) => ({ ...result, ...flattenFlexEntityDataSection(currentSectionData, nestedSection) }),
		{} as any
	);
	const fieldsData = schema.fields.reduce(
		(result, field) => ({ ...result, [field.attribute.identifier]: getAttributeValue(currentSectionData, field.attribute.identifier) }),
		{} as any
	);

	return { ...sectionsData, ...fieldsData };
};

export const flattenFlexEntitySection = (data: any, schema: FlexEntitySchema): any => {
	return schema.sections.reduce((result, section) => ({ ...result, ...flattenFlexEntityDataSection(data, section) }), {} as any);
};
